import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './job-data.reducer';
import { JobDataService } from './job-data.service';
import { JobDataEffects } from './job-data.effects';
import { JobDataStore } from './job-data.store';
import { JobDataDispatcher } from './job-data.dispatcher';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([JobDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
  declarations: [],
})
export class JobDataModule {
  static forRoot(): ModuleWithProviders<JobDataModule> {
    return {
      ngModule: JobDataModule,
      providers: [JobDataService, JobDataStore, JobDataDispatcher],
    };
  }
}
